import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { DatepickerCalendarComponent } from 'app/Shared/Component/datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from 'app/Shared/Component/datepicker-calendar/datepicker.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';


@Component({
    selector: 'app-file-actions',
    templateUrl: './file-actions.component.html',
    styleUrls: ['./file-actions.component.scss'],
    imports: [MatDividerModule, ToastModule, CommonModule, Select, RouterModule, FormsModule, DatePickerModule, DatepickerCalendarComponent, MultiSelectModule]
})
export class FileActionsComponent implements OnInit, OnChanges {
  reconvalues: any = ['Cat2Cat','ClientAndCat','CatDetailRecon'];
  reconTypes : any = [{key:'CAT To CAT', value:'Cat2Cat'},{key:'Client And CAT', value:'ClientAndCat'},{key:'CAT Detail', value:'CatDetailRecon'}];
  public currentDate: Date = new Date();
  reportDate: any = new Date();
  reporter: any;
  isLoadingGroupList: boolean = false;
  groupListDropDown: any = [];
  isFileProcessingStated!: boolean;
  @Input('fileProcessingType') fileProcessingType: any="CAT";
  selectedGroup!: string;
  constructor(private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    public userService: UserService,
    private datepickerService:DatepickerService,
  ) { }

  ngOnInit() {
    this.datepickerService.reportDate = this.reportDate;
    this.selectedGroup = this.userService.getActiveMPID();
    this.getGroupList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.fileProcessingType=='CAT Exceptions Restore' || this.fileProcessingType === 'Comparative Review') {
      this.groupListDropDown = [];
      this.getGroupList();
    }
  }

  getGroupList() {
    this.isLoadingGroupList = true;
    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Get_Group_List),
      {
        validationType: this.fileProcessingType ?? "CAT" ,
        mpid: this.userService.getActiveMPID(),
        reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
      })
      .subscribe({
        next:(response:any) => {
        let result = response;
        this.groupListDropDown = [];
        let DataSet: any[] = result.Data;
        
        if (DataSet && DataSet.length > 0) {
          if(this.fileProcessingType === 'Comparative Review') {
            
            this.groupListDropDown.push({ label: "ALL", value: "ALL", inActive: false });
            this.selectedGroup = "ALL";
            for (let i = 0; i < DataSet.length; i++) {
              const inActive = DataSet[i].ExecuteCATClientCompReview === "Y" ? false : true;
              this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName, inActive: inActive });
            }

          } else {
            for (let i = 0; i < DataSet.length; i++) {
              this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName });
            }
          }
        }

        this.isLoadingGroupList = false;

      },
        error:(err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: "Loading group list", detail: "Data not found for that report date." });
          this.isLoadingGroupList = false;
      }});
  }

  catScriptCall() {
    this.messageService.add({ severity: 'success', summary: "File Processing", detail: (this.fileProcessingType + " Processing Started") });
    this.userService.logUserActivity(this.fileProcessingType, null, {
      'Text1': this.fileProcessingType + ' Processing Started by ' + this.userService.getUserName() + ' for the Report Date: ' + this.userService.getyyyyMMddDateFormate(this.reportDate) + ' and File Group: ' + this.selectedGroup,
      'Text2': (this.fileProcessingType && this.fileProcessingType.length > 0 ? this.fileProcessingType : '') + ' Processing Started'
    });

    this.isFileProcessingStated = true;
    let apiPayload = {
      scriptType: "CAT",
      fileProcessType: this.fileProcessingType,
      scriptProcessType : this.reconvalues!=undefined && this.reconvalues.length> 0 ? this.reconvalues.join('-'):null,
      mpid: this.userService.getActiveMPID(),
      submitterID: this.selectedGroup,
      reporterID: this.userService.getActiveMPID(),
      groupName: this.selectedGroup,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
      user: this.userService.userFirstName,
      genCatEvents: "N",
    };
    let tempURl = this.urlsService.setAPIURl(
      APIURL.RunScript);
    this.sharedHttpClientService.post(tempURl, apiPayload)
      .subscribe({
        next:(response:any) => {
        let result = response;
        this.isFileProcessingStated = false;
        if (result.isScripttypeFailed == "true") {
          this.messageService.add({ severity: 'error', summary: result.Scripttype, detail: (this.fileProcessingType + " Processing Failed") });
          this.userService.logUserActivity(this.fileProcessingType, null, {
            'Text1': this.fileProcessingType + ' Processing Failed triggered by ' + this.userService.getUserName() + ' for the Report Date: ' + this.userService.getyyyyMMddDateFormate(this.reportDate) + (this.selectedGroup && this.selectedGroup.length  > 0 ? ' and File Group: ' + this.selectedGroup : ''),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(apiPayload)
          });
        } else {
          this.messageService.add({ severity: 'success', summary: result.Scripttype, detail: (this.fileProcessingType + " Processing Completed") });
          this.userService.logUserActivity((this.fileProcessingType), null, {
            'Text1': this.fileProcessingType + ' Processing Completed triggered by ' + this.userService.getUserName() + ' for the Report Date: ' + this.userService.getyyyyMMddDateFormate(this.reportDate) + (this.selectedGroup && this.selectedGroup.length  > 0 ? ' and File Group: ' + this.selectedGroup : '') ,
            'Text2': 'User Filter Parameters: ' + JSON.stringify(apiPayload)
          });
        }
      },
        error:(err: HttpErrorResponse) => {
          this.isFileProcessingStated = false;
   } });
  }

  getGroupListDateChange() {
    this.getGroupList();
  }
  getDateEmitter(event:any){
    this.reportDate = this.datepickerService.reportDate;
    this.getGroupList();
  }

}

